import React from 'react';
import Image from 'next/legacy/image';

import iconThumbs from '../../../public/images/icon_thumbsV2.svg';
import iconList from '../../../public/images/icon_listV2.svg';
import iconThumbsClicked from '../../../public/images/icons_thumbs_clickedV2.svg';
import iconListClicked from '../../../public/images/icon_list_clickedV2.svg';

import BuildingPageMoreFiltersV2 from 'componentsV2/BuldingV2/BuildingPageMoreFiltersV2';
import { FiltersValues, SetFiltersValues } from 'components/UnitsFilters/types';
import UnitsSortingV2 from 'componentsV2/UnitsFiltersV2/UnitsSortingV2';

interface Props {
  renderCards: boolean;
  setRenderCards: (isTableMode: boolean) => void;
  setSortOption: React.Dispatch<React.SetStateAction<string>>;
  setFiltersValues: SetFiltersValues;
  filtersValues: FiltersValues;
  buildingId: number;
  selectedPropertyType: 'rent' | 'sale';
}

const AvailableCondoFilterV2: React.FC<Props> = ({
  renderCards,
  setRenderCards,
  selectedPropertyType,
  filtersValues,
  setFiltersValues,
  setSortOption,
  buildingId,
}) => {
  return (
    <div className="flex flex-col  mb-12 lg:flex-row">
      <div className="flex items-center flex-row gap-[21px]">
        <div className="flex items-center flex-row">
          <BuildingPageMoreFiltersV2
            buildingId={buildingId}
            values={filtersValues}
            setValues={setFiltersValues}
            propertyType={selectedPropertyType}
          />
          <UnitsSortingV2
            onChange={setSortOption}
            rootClassName={
              'lg:mt-0 h-[46px]  w-[144px]  text-16-26-0.3 pl-[16px]'
            }
            selectClassName="h-[46px] -left-0.1 top-12"
          />
        </div>
        <div className="flex items-center flex-row gap-[10px]">
          <button className="" onClick={() => setRenderCards(true)}>
            <Image
              src={renderCards ? iconThumbsClicked : iconThumbs}
              alt="icon-thumbs"
              height={25}
              width={25}
            />
          </button>
          <button className="" onClick={() => setRenderCards(false)}>
            <Image
              src={renderCards ? iconList : iconListClicked}
              alt="icon-list"
              height={25}
              width={25}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvailableCondoFilterV2;
